import * as React from 'react';
import { connect } from 'react-redux';
import './AverageKilometersTravelled.css';
import { handleNextStep, setQuoteData } from '../../../../actions/salesActions';
import { Button } from 'react-bootstrap';
import KPDropdown from '../../../BaseTemplate/SSPCustomComponentLibrary/KPDropdown/KPDropdown';

class AverageKilometersTravelled extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            kmSelected: this.props.sales.averageKilometers ? this.props.sales.averageKilometers.toString() : "",
            kmList: [{ id: 1, description: "0 - 1000" }, { id: 2, description: "1001 - 2000" }, { id: 3, description: "2001 - 4000" }, { id: 4, description: "4000 +" }],
            nextDisabled: true
        }

        this.handleNextStep = this.handleNextStep.bind(this);
        this.checkSubmit = this.checkSubmit.bind(this);
    }

    async componentDidMount() {
        this.checkSubmit();
    }

    async checkSubmit() {
        let valid = this.state.kmSelected !== "";
        this.setState({ nextDisabled: !valid });
    }

    async handleNextStep() {
        let payload = {
            averageKilometers: Number(this.state.kmSelected)
        };
        await this.props.dispatchAction(setQuoteData(payload));
        await this.props.dispatchAction(handleNextStep());
    }

    async handleKmList(e:any) {
        await this.setState({
            kmSelected: e
        });
        this.checkSubmit();
    }

    public render() {
        let selectedValue = (this.state.kmSelected && this.state.kmList.filter(x => x.id.toString() === this.state.kmSelected).length > 0)
            ? this.state.kmList.filter(x => x.id.toString() === this.state.kmSelected)[0].description
            : "";

        return (
            <div style={{ marginBottom:"120px"}} >
                <p className="text-16 text-center font-weight-500 mb-15px mt-10">Cool, now we need to know how far this car drives in an average month.</p>

                <KPDropdown
                    id={"kmRange"}
                    className={"ssp-popup-dropdown"}
                    label={"Average km a month"}
                    labelAfterSelection={"Average km a month"}
                    showLabelAfterSelection={true}
                    showLabelInside={false}
                    showLabelOutside={true}
                    data={this.state.kmList}
                    handleSelection={(e) => this.handleKmList(e)}
                    isRiskItem={false}
                    selectedValue={selectedValue}
                />

                <div className="row d-flex justify-content-center mt-lg-4">
                    <Button type="button" className="btn btn-block btn-solid-red mt-5 ml-16px mr-16px mt-lg-0 pl-3 cursor-pointer" id="NextButton" onClick={this.handleNextStep} disabled={this.state.nextDisabled}>Next</Button>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AverageKilometersTravelled);